let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("d0FRs"), load("ffEVr"), load("kjZZD"), load("aGZFn"), load("eWCiQ")]).then(() => parcelRequire('edScR'));